const production = false

export const BASE_URL = production ? 'https://retail.loyal.id/api/v1/' : 'https://retail-dev.loyal.id/api/v1/'

export const CLIENT_CODE = '070801'